module.exports = __webpack_public_path__ + "static/media/gaming10.3ac08424.webp";